import React from "react";
import { useInView } from '../hooks/useInView';
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React.js",
    "Node.js",
    "Next.js",
    "Flask",
    "FastAPI",
    "JavaScript",
    "TypeScript",
    "HTML5",
    "CSS3",
    "WordPress",
];

const labelsSecond = [
    "Git",
    "VS Code",
    "IntelliJ",
    "PyCharm",
    "Microsoft Azure",
    "Google Cloud Platform",
    "Vercel",
    "Heroku",
];

const labelsThird = [
    "Java",
    "Python",
    "SQL",
    "Pandas",
    "NumPy",
    "Matplotlib",
    "Machine Learning",
    "AI Solutions",
];

function Expertise() {
    const { ref, inView } = useInView({ threshold: 0.1 });
    
    return (
    <div ref={ref} className={`container expertise-container section-fade ${inView ? 'in-view' : ''}`} id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Full Stack Web Development</h3>
                    <p>Experienced in building modern, responsive web applications from scratch using React.js, Node.js, Next.js, Flask, and FastAPI. Proficient in the complete SDLC with expertise in both frontend and backend technologies, delivering scalable and secure solutions.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>AI & Machine Learning</h3>
                    <p>Specialized in developing AI-driven solutions for real-world applications including fraud detection, risk analysis, product recommendation systems, and chatbots. Experience with ML pipelines, data analytics, and deploying production-ready AI models for banking and insurance domains.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Cloud & DevOps</h3>
                    <p>Skilled in cloud deployment and DevOps practices with hands-on experience in Microsoft Azure, Google Cloud Platform, Vercel, and Heroku. Proficient in CI/CD pipelines, version control with Git, and using modern development tools for efficient project delivery.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;